var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#e6e6e6",
    d: "m237,2.3l-4.06,-2.36l-207.19,119.6l0,173.23a3.06,3.06 0 0 0 1.26,2.8l0,0l4.06,2.36l0,0a3.06,3.06 0 0 0 3.07,-0.3l198.5,-114.63a9.58,9.58 0 0 0 4.33,-7.5l0.03,-173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#fafafa",
    d: "m29.81,295.13c0,2.76 1.93,3.88 4.33,2.5l198.5,-114.63a9.58,9.58 0 0 0 4.33,-7.5l0,-173.2l-207.16,119.61l0,173.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#e0e0e0",
    d: "m236,4l0,171.52a8.61,8.61 0 0 1 -3.83,6.64l-198.5,114.6a3,3 0 0 1 -1.44,0.46c-1.26,0 -1.39,-1.46 -1.39,-2.09l0,-172.65l205.16,-118.48m1,-1.73l-207.19,119.64l0,173.22c0,2 1,3.09 2.39,3.09a4,4 0 0 0 1.94,-0.59l198.5,-114.63a9.58,9.58 0 0 0 4.33,-7.5l0,-173.2l0.03,-0.03z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_4",
    fill: "#696CFF",
    points: "29.80999755859375,121.91000366210938 29.80999755859375,140.66000366210938 236.97000122070312,21.050003051757812 236.97000122070312,2.3000030517578125 29.80999755859375,121.91000366210938 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#fafafa",
    d: "m159.79,54.21l0,4c0,0.82 0.59,1.16 1.3,0.75l63.69,-36.78l0,-7l-63.69,36.82a2.9,2.9 0 0 0 -1.3,2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#455a64",
    d: "m231.61,11.25c0.72,-0.42 1.3,-0.08 1.3,0.75l0,4a2.86,2.86 0 0 1 -1.3,2.25l-6.83,3.94l0,-7l6.83,-3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#fafafa",
    d: "m231.11,16.78l-0.77,-0.24a4.06,4.06 0 0 0 0.13,-1a1.78,1.78 0 0 0 -0.7,-1.62a1.09,1.09 0 0 0 -1.11,0a3.89,3.89 0 0 0 -1.52,3.17a1.76,1.76 0 0 0 0.7,1.62a0.89,0.89 0 0 0 0.48,0.13a1.25,1.25 0 0 0 0.62,-0.18a3.16,3.16 0 0 0 1.23,-1.65l0.77,0.24l0.06,0a0.28,0.28 0 0 0 0.27,-0.19a0.29,0.29 0 0 0 -0.16,-0.28zm-2.45,1.46a0.51,0.51 0 0 1 -0.54,0.05a1.29,1.29 0 0 1 -0.41,-1.13a3.39,3.39 0 0 1 1.23,-2.68a0.74,0.74 0 0 1 0.35,-0.11a0.36,0.36 0 0 1 0.2,0.06a1.32,1.32 0 0 1 0.41,1.13a3.4,3.4 0 0 1 -1.24,2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#f5f5f5",
    d: "m34.14,297.63l36.29,-20.95l0,-159.48l-40.62,23.46l0,154.47c0,2.76 1.93,3.87 4.33,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#e0e0e0",
    d: "m69.43,118.93l0,157.17l-35.79,20.66a3,3 0 0 1 -1.44,0.46c-1.26,0 -1.39,-1.46 -1.39,-2.09l0,-153.9l38.62,-22.3m1,-1.73l-40.62,23.46l0,154.47c0,2 1,3.09 2.39,3.09a4,4 0 0 0 1.94,-0.59l36.29,-20.95l0,-159.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#e0e0e0",
    d: "m43.29,142.25l19.44,-11.25c0.71,-0.42 1.29,-0.08 1.29,0.75l0,1.69a2.89,2.89 0 0 1 -1.29,2.25l-19.44,11.23c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.67a2.9,2.9 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    fill: "#696CFF",
    d: "m37.93,146.85l0,1.69a2.87,2.87 0 0 1 -1.3,2.25l-1.46,0.84c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.69a2.87,2.87 0 0 1 1.3,-2.25l1.46,-0.84c0.72,-0.42 1.3,-0.1 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    fill: "#e0e0e0",
    d: "m43.29,151.6l19.44,-11.23c0.71,-0.42 1.29,-0.08 1.29,0.74l0,1.69a2.91,2.91 0 0 1 -1.29,2.26l-19.44,11.23c-0.72,0.41 -1.3,0.08 -1.3,-0.75l0,-1.69a2.88,2.88 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "#696CFF",
    d: "m37.93,156.19l0,1.69a2.86,2.86 0 0 1 -1.3,2.25l-1.46,0.85c-0.72,0.41 -1.3,0.08 -1.3,-0.75l0,-1.69a2.86,2.86 0 0 1 1.3,-2.25l1.46,-0.85c0.72,-0.44 1.3,-0.08 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "#e0e0e0",
    d: "m43.29,160.94l19.44,-11.23c0.71,-0.41 1.29,-0.08 1.29,0.75l0,1.69a2.87,2.87 0 0 1 -1.29,2.25l-19.44,11.23c-0.72,0.42 -1.3,0.08 -1.3,-0.74l0,-1.7a2.91,2.91 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#696CFF",
    d: "m37.93,165.54l0,1.69a2.86,2.86 0 0 1 -1.3,2.25l-1.46,0.85c-0.72,0.41 -1.3,0.07 -1.3,-0.75l0,-1.7a2.89,2.89 0 0 1 1.3,-2.25l1.46,-0.84c0.72,-0.41 1.3,-0.08 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "#e0e0e0",
    d: "m43.29,191.94l19.44,-11.24c0.71,-0.41 1.29,-0.08 1.29,0.75l0,1.69a2.87,2.87 0 0 1 -1.29,2.25l-19.44,11.24c-0.72,0.41 -1.3,0.08 -1.3,-0.75l0,-1.69a2.88,2.88 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "#696CFF",
    d: "m37.93,196.53l0,1.69a2.86,2.86 0 0 1 -1.3,2.25l-1.46,0.85c-0.72,0.41 -1.3,0.08 -1.3,-0.75l0,-1.69a2.86,2.86 0 0 1 1.3,-2.25l1.46,-0.85c0.72,-0.41 1.3,-0.08 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "#e0e0e0",
    d: "m43.29,200.21l19.44,-11.21c0.71,-0.41 1.29,-0.08 1.29,0.75l0,1.69a2.87,2.87 0 0 1 -1.29,2.25l-19.44,11.21c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.69a2.91,2.91 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "#696CFF",
    d: "m37.93,204.81l0,1.69a2.86,2.86 0 0 1 -1.3,2.25l-1.46,0.84c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.69a2.89,2.89 0 0 1 1.3,-2.25l1.46,-0.84c0.72,-0.41 1.3,-0.06 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#e0e0e0",
    d: "m43.29,208.49l19.44,-11.23c0.71,-0.42 1.29,-0.08 1.29,0.75l0,1.69a2.89,2.89 0 0 1 -1.29,2.25l-19.44,11.23c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.69a2.9,2.9 0 0 1 1.3,-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "#696CFF",
    d: "m37.93,213.09l0,1.69a2.87,2.87 0 0 1 -1.3,2.25l-1.46,0.84c-0.72,0.42 -1.3,0.08 -1.3,-0.75l0,-1.69a2.87,2.87 0 0 1 1.3,-2.25l1.46,-0.84c0.72,-0.42 1.3,-0.08 1.3,0.75z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_22",
    fill: "#696CFF",
    points: "41.99000549316406,171.14999389648438 41.99000549316406,174.05999755859375 44.52000427246094,171.14999389648438 41.99000549316406,171.14999389648438 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "#e0e0e0",
    d: "m46.06,170.54c0,0.55 0.38,0.76 0.86,0.48l16.24,-9.34a1.91,1.91 0 0 0 0.86,-1.5c0,-0.55 -0.38,-0.77 -0.86,-0.49l-16.24,9.37a1.89,1.89 0 0 0 -0.86,1.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_24",
    fill: "#696CFF",
    points: "41.99000549316406,175.83001708984375 41.99000549316406,178.75 44.52000427246094,175.83001708984375 41.99000549316406,175.83001708984375 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "#e0e0e0",
    d: "m46.06,175.23c0,0.54 0.38,0.76 0.86,0.48l16.24,-9.35a1.88,1.88 0 0 0 0.86,-1.49c0,-0.55 -0.38,-0.77 -0.86,-0.49l-16.24,9.37a1.89,1.89 0 0 0 -0.86,1.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_26",
    fill: "#696CFF",
    points: "41.99000549316406,180.51998901367188 41.99000549316406,183.44000244140625 44.52000427246094,180.51998901367188 41.99000549316406,180.51998901367188 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "#e0e0e0",
    d: "m46.06,179.92c0,0.54 0.38,0.76 0.86,0.48l16.24,-9.35a1.88,1.88 0 0 0 0.86,-1.49c0,-0.55 -0.38,-0.77 -0.86,-0.49l-16.24,9.37a1.89,1.89 0 0 0 -0.86,1.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_28",
    fill: "#696CFF",
    points: "41.99000549316406,185.20999145507812 41.99000549316406,188.1300048828125 44.52000427246094,185.20999145507812 41.99000549316406,185.20999145507812 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    fill: "#e0e0e0",
    d: "m46.06,184.61c0,0.54 0.38,0.76 0.86,0.48l16.24,-9.35a1.88,1.88 0 0 0 0.86,-1.49c0,-0.55 -0.38,-0.77 -0.86,-0.49l-16.24,9.37a1.89,1.89 0 0 0 -0.86,1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    fill: "#696CFF",
    d: "m82.61,122.79l0,24.44c0,1 0.72,1.44 1.61,0.93l26.87,-15.52a3.53,3.53 0 0 0 1.61,-2.78l0,-20.09c0,-1 -0.72,-1.44 -1.61,-0.93l-15.59,9c-0.89,0.51 -1.61,0.1 -1.61,-0.92l0,-0.64c0,-1 -0.71,-1.44 -1.6,-0.93l-8.07,4.65a3.56,3.56 0 0 0 -1.61,2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    fill: "#e0e0e0",
    d: "m87.9,151.84l0,1.57c0,0.76 0.54,1.07 1.2,0.69l20.16,-11.64a2.65,2.65 0 0 0 1.2,-2.08l0,-1.57c0,-0.76 -0.54,-1.07 -1.2,-0.69l-20.16,11.64a2.65,2.65 0 0 0 -1.2,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    fill: "#696CFF",
    d: "m120,101.34l0,24.44c0,1 0.72,1.43 1.6,0.92l26.87,-15.51a3.56,3.56 0 0 0 1.61,-2.78l0,-20.1c0,-1 -0.72,-1.44 -1.61,-0.93l-15.59,9c-0.89,0.51 -1.6,0.09 -1.6,-0.93l0,-0.64c0,-1 -0.72,-1.43 -1.61,-0.92l-8.07,4.66a3.55,3.55 0 0 0 -1.6,2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    fill: "#e0e0e0",
    d: "m125.26,130.39l0,1.61c0,0.77 0.54,1.08 1.2,0.7l20.16,-11.7a2.68,2.68 0 0 0 1.2,-2.09l0,-1.56c0,-0.77 -0.54,-1.08 -1.2,-0.69l-20.16,11.64a2.68,2.68 0 0 0 -1.2,2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    fill: "#696CFF",
    d: "m82.61,171.89l0,24.44c0,1 0.72,1.44 1.61,0.93l26.87,-15.52a3.55,3.55 0 0 0 1.61,-2.74l0,-20.1c0,-1 -0.72,-1.43 -1.61,-0.92l-15.59,9c-0.89,0.51 -1.61,0.1 -1.61,-0.92l0,-0.64c0,-1 -0.71,-1.44 -1.6,-0.93l-8.07,4.66a3.55,3.55 0 0 0 -1.61,2.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    fill: "#e0e0e0",
    d: "m87.9,200.94l0,1.57c0,0.76 0.54,1.07 1.2,0.69l20.16,-11.64a2.67,2.67 0 0 0 1.2,-2.08l0,-1.57c0,-0.76 -0.54,-1.07 -1.2,-0.69l-20.16,11.64a2.65,2.65 0 0 0 -1.2,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    fill: "#696CFF",
    d: "m120,150.43l0,24.44c0,1 0.72,1.44 1.6,0.93l26.87,-15.52a3.53,3.53 0 0 0 1.61,-2.77l0,-20.1c0,-1 -0.72,-1.44 -1.61,-0.93l-15.59,9c-0.89,0.51 -1.6,0.09 -1.6,-0.93l0,-0.64c0,-1 -0.72,-1.44 -1.61,-0.92l-8.07,4.66a3.54,3.54 0 0 0 -1.6,2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_37",
    fill: "#e0e0e0",
    d: "m125.26,179.49l0,1.56c0,0.77 0.54,1.08 1.2,0.69l20.16,-11.63a2.68,2.68 0 0 0 1.2,-2.09l0,-1.56c0,-0.77 -0.54,-1.08 -1.2,-0.7l-20.16,11.64a2.68,2.68 0 0 0 -1.2,2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_38",
    fill: "#696CFF",
    d: "m157.78,78.7l0,24.44c0,1 0.72,1.44 1.6,0.93l26.88,-15.52a3.55,3.55 0 0 0 1.6,-2.78l0,-20.09c0,-1 -0.72,-1.44 -1.6,-0.93l-15.6,9c-0.88,0.52 -1.6,0.1 -1.6,-0.92l0,-0.64c0,-1 -0.72,-1.44 -1.61,-0.93l-8.07,4.67a3.54,3.54 0 0 0 -1.6,2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_39",
    fill: "#e0e0e0",
    d: "m162.62,108.93l0,1.57c0,0.76 0.54,1.07 1.21,0.69l20.17,-11.64a2.64,2.64 0 0 0 1.21,-2.08l0,-1.56c0,-0.77 -0.54,-1.08 -1.21,-0.7l-20.15,11.64a2.64,2.64 0 0 0 -1.23,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_40",
    fill: "#696CFF",
    d: "m194.7,58.43l0,24.44c0,1 0.72,1.43 1.61,0.92l26.87,-15.51a3.55,3.55 0 0 0 1.6,-2.78l0,-20.1c0,-1 -0.71,-1.44 -1.6,-0.93l-15.59,9c-0.89,0.51 -1.61,0.09 -1.61,-0.93l0,-0.64c0,-1 -0.71,-1.43 -1.6,-0.92l-8.07,4.66a3.53,3.53 0 0 0 -1.61,2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_41",
    fill: "#e0e0e0",
    d: "m200,87.48l0,1.52c0,0.77 0.53,1.08 1.2,0.7l20.16,-11.64a2.68,2.68 0 0 0 1.2,-2.08l0,-1.57c0,-0.77 -0.54,-1.08 -1.2,-0.69l-20.16,11.63a2.66,2.66 0 0 0 -1.2,2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_42",
    fill: "#e0e0e0",
    d: "m162.62,158l0,1.57c0,0.76 0.54,1.07 1.21,0.69l20.17,-11.63a2.64,2.64 0 0 0 1.21,-2.08l0,-1.55c0,-0.76 -0.54,-1.07 -1.21,-0.69l-20.15,11.64a2.64,2.64 0 0 0 -1.23,2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_43",
    fill: "#fafafa",
    d: "m163.13,123.66l20.87,-12.07c0.95,-0.55 1.73,-0.1 1.73,1l0,24.14a3.83,3.83 0 0 1 -1.73,3l-20.87,12.07c-1,0.55 -1.73,0.11 -1.73,-1l0,-24.14a3.84,3.84 0 0 1 1.73,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_44",
    fill: "#ebebeb",
    d: "m162.35,152.54a1.4,1.4 0 0 1 -0.7,-0.18a1.7,1.7 0 0 1 -0.75,-1.56l0,-24.14a4.32,4.32 0 0 1 2,-3.43l20.91,-12.07a1.68,1.68 0 0 1 1.72,-0.12a1.71,1.71 0 0 1 0.76,1.55l0,24.14a4.32,4.32 0 0 1 -2,3.43l-20.91,12.08a2.09,2.09 0 0 1 -1.03,0.3zm22.46,-40.68a1,1 0 0 0 -0.52,0.17l-20.91,12.07a3.3,3.3 0 0 0 -1.48,2.56l0,24.14c0,0.35 0.09,0.6 0.25,0.69a0.8,0.8 0 0 0 0.73,-0.12l20.91,-12.07a3.35,3.35 0 0 0 1.48,-2.57l0,-24.14a0.8,0.8 0 0 0 -0.26,-0.69a0.42,0.42 0 0 0 -0.2,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_45",
    fill: "#696CFF",
    d: "m186.5,114.85l-4.66,2.69a3.83,3.83 0 0 0 -1.74,3l0,5.38c0,1.11 0.78,1.56 1.74,1l4.66,-2.69a3.83,3.83 0 0 0 1.73,-3l0,-5.38c0,-1.1 -0.78,-1.55 -1.73,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_46",
    fill: "#ebebeb",
    d: "m164.72,126.27l10.48,-6c0.47,-0.27 0.86,-0.05 0.86,0.51l0,0.33a1.94,1.94 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.87,0.06 -0.86,-0.5l0,-0.34a1.91,1.91 0 0 1 0.86,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_47",
    fill: "#ebebeb",
    d: "m164.72,131l10.48,-6c0.47,-0.28 0.86,-0.05 0.86,0.5l0,0.33a1.91,1.91 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.87,0 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_48",
    fill: "#ebebeb",
    d: "m164.72,135.64l10.48,-6c0.47,-0.27 0.86,-0.05 0.86,0.5l0,0.34a1.94,1.94 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.87,0.06 -0.86,-0.5l0,-0.34a1.9,1.9 0 0 1 0.86,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_49",
    fill: "#ebebeb",
    d: "m164.72,140.32l17.4,-10c0.48,-0.27 0.87,0 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.87,0.05 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_50",
    fill: "#ebebeb",
    d: "m164.72,145l17.4,-10c0.48,-0.28 0.87,0 0.87,0.5l0,0.33a1.91,1.91 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.87,0.05 -0.86,-0.5l0,-0.34a1.88,1.88 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_51",
    fill: "#e0e0e0",
    d: "m199.18,136.91l0,1.56c0,0.77 0.54,1.08 1.2,0.7l20.16,-11.64a2.66,2.66 0 0 0 1.2,-2.09l0,-1.56c0,-0.77 -0.53,-1.08 -1.2,-0.7l-20.16,11.64a2.68,2.68 0 0 0 -1.2,2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_52",
    fill: "#fafafa",
    d: "m199.69,102.56l20.9,-12.07c1,-0.56 1.74,-0.11 1.74,1l0,24.14a3.85,3.85 0 0 1 -1.74,3l-20.9,12.07c-1,0.55 -1.74,0.1 -1.74,-1l0,-24.14a3.82,3.82 0 0 1 1.74,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_53",
    fill: "#ebebeb",
    d: "m198.91,131.43a1.4,1.4 0 0 1 -0.7,-0.18a1.71,1.71 0 0 1 -0.76,-1.55l0,-24.14a4.32,4.32 0 0 1 2,-3.44l20.9,-12.07a1.55,1.55 0 0 1 2.49,1.44l0,24.14a4.31,4.31 0 0 1 -2,3.43l-20.9,12.07a2.09,2.09 0 0 1 -1.03,0.3zm1,-28.44a3.32,3.32 0 0 0 -1.49,2.57l0,24.14a0.8,0.8 0 0 0 0.26,0.69a0.78,0.78 0 0 0 0.73,-0.13l20.9,-12.07a3.31,3.31 0 0 0 1.49,-2.56l0,-24.14a0.58,0.58 0 0 0 -1,-0.57l-20.89,12.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_54",
    fill: "#696CFF",
    d: "m223.05,93.75l-4.66,2.69a3.83,3.83 0 0 0 -1.73,3l0,5.38c0,1.1 0.78,1.55 1.73,1l4.66,-2.69a3.85,3.85 0 0 0 1.74,-3l0,-5.38c0,-1.11 -0.79,-1.56 -1.74,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_55",
    fill: "#ebebeb",
    d: "m201.28,105.16l10.47,-6c0.48,-0.28 0.87,0 0.87,0.5l0,0.34a1.89,1.89 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.28 -0.87,0.05 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_56",
    fill: "#ebebeb",
    d: "m201.28,109.85l10.47,-6c0.48,-0.27 0.87,0 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.28 -0.87,0.06 -0.87,-0.5l0,-0.34a1.91,1.91 0 0 1 0.87,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_57",
    fill: "#ebebeb",
    d: "m201.28,114.53l10.47,-6c0.48,-0.28 0.87,0 0.87,0.5l0,0.33a1.91,1.91 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.27 -0.87,0.05 -0.87,-0.5l0,-0.36a1.92,1.92 0 0 1 0.87,-1.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_58",
    fill: "#ebebeb",
    d: "m201.28,119.22l17.4,-10c0.48,-0.28 0.87,-0.05 0.87,0.5l0,0.28a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.87,0.05 -0.87,-0.5l0,-0.34a1.89,1.89 0 0 1 0.87,-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_59",
    fill: "#ebebeb",
    d: "m201.28,123.9l17.4,-10c0.48,-0.27 0.87,-0.05 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.87,0.05 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_60",
    fill: "#e0e0e0",
    d: "m162.62,207.83l0,1.57c0,0.76 0.54,1.07 1.21,0.69l20.17,-11.64a2.64,2.64 0 0 0 1.21,-2.08l0,-1.57c0,-0.76 -0.54,-1.07 -1.21,-0.69l-20.15,11.64a2.64,2.64 0 0 0 -1.23,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_61",
    fill: "#fafafa",
    d: "m163.13,173.48l20.87,-12.07c0.95,-0.55 1.73,-0.1 1.73,1l0,24.14a3.85,3.85 0 0 1 -1.73,3l-20.91,12.07c-1,0.55 -1.73,0.11 -1.73,-1l0,-24.14a3.82,3.82 0 0 1 1.77,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_62",
    fill: "#ebebeb",
    d: "m162.35,202.36a1.4,1.4 0 0 1 -0.7,-0.18a1.72,1.72 0 0 1 -0.75,-1.56l0,-24.14a4.32,4.32 0 0 1 2,-3.43l20.89,-12.05a1.55,1.55 0 0 1 2.48,1.43l0,24.14a4.32,4.32 0 0 1 -2,3.43l-20.91,12.07a2.11,2.11 0 0 1 -1.01,0.29zm22.46,-40.69a1.09,1.09 0 0 0 -0.52,0.17l-20.91,12.08a3.29,3.29 0 0 0 -1.48,2.56l0,24.14a0.58,0.58 0 0 0 1,0.57l20.91,-12.07a3.35,3.35 0 0 0 1.48,-2.57l0,-24.14a0.8,0.8 0 0 0 -0.26,-0.69a0.42,0.42 0 0 0 -0.22,-0.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_63",
    fill: "#696CFF",
    d: "m186.5,164.67l-4.66,2.69a3.83,3.83 0 0 0 -1.74,3l0,5.38c0,1.11 0.78,1.55 1.74,1l4.66,-2.69a3.83,3.83 0 0 0 1.73,-3l0,-5.38c0,-1.1 -0.78,-1.55 -1.73,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_64",
    fill: "#ebebeb",
    d: "m164.72,176.09l10.48,-6c0.47,-0.27 0.86,-0.05 0.86,0.5l0,0.34a1.94,1.94 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.87,0.06 -0.86,-0.5l0,-0.34a1.9,1.9 0 0 1 0.86,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_65",
    fill: "#ebebeb",
    d: "m164.72,180.77l10.48,-6c0.47,-0.28 0.86,-0.05 0.86,0.5l0,0.33a1.92,1.92 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.27 -0.87,0.05 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_66",
    fill: "#ebebeb",
    d: "m164.72,185.46l10.48,-6c0.47,-0.27 0.86,-0.05 0.86,0.5l0,0.34a1.94,1.94 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.87,0.05 -0.86,-0.5l0,-0.3a1.88,1.88 0 0 1 0.86,-1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_67",
    fill: "#ebebeb",
    d: "m164.72,190.14l17.4,-10c0.48,-0.27 0.87,-0.05 0.87,0.5l0,0.36a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.87,0.05 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_68",
    fill: "#ebebeb",
    d: "m164.72,194.83l17.4,-10c0.48,-0.28 0.87,-0.06 0.87,0.5l0,0.33a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.87,0.05 -0.86,-0.5l0,-0.34a1.88,1.88 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_69",
    fill: "#e0e0e0",
    d: "m199.18,186.72l0,1.57c0,0.77 0.54,1.08 1.2,0.69l20.16,-11.63a2.66,2.66 0 0 0 1.2,-2.09l0,-1.56c0,-0.77 -0.53,-1.08 -1.2,-0.7l-20.16,11.64a2.68,2.68 0 0 0 -1.2,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_70",
    fill: "#fafafa",
    d: "m199.69,152.38l20.9,-12.07c1,-0.56 1.74,-0.11 1.74,1l0,24.13a3.82,3.82 0 0 1 -1.74,3l-20.9,12.08c-1,0.55 -1.74,0.1 -1.74,-1l0,-24.14a3.82,3.82 0 0 1 1.74,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_71",
    fill: "#ebebeb",
    d: "m198.91,181.25a1.4,1.4 0 0 1 -0.7,-0.18a1.71,1.71 0 0 1 -0.76,-1.55l0,-24.14a4.31,4.31 0 0 1 2,-3.44l20.9,-12.07a1.55,1.55 0 0 1 2.49,1.44l0,24.13a4.31,4.31 0 0 1 -2,3.44l-20.9,12.12a2.09,2.09 0 0 1 -1.03,0.25zm1,-28.44a3.32,3.32 0 0 0 -1.49,2.57l0,24.14a0.76,0.76 0 0 0 0.26,0.68a0.77,0.77 0 0 0 0.73,-0.12l20.93,-12.08a3.32,3.32 0 0 0 1.49,-2.57l0,-24.12a0.58,0.58 0 0 0 -1,-0.57l-20.92,12.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_72",
    fill: "#696CFF",
    d: "m223.05,143.57l-4.66,2.69a3.83,3.83 0 0 0 -1.73,3l0,5.38c0,1.1 0.78,1.55 1.73,1l4.66,-2.69a3.85,3.85 0 0 0 1.74,-3l0,-5.38c0,-1.11 -0.79,-1.57 -1.74,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_73",
    fill: "#ebebeb",
    d: "m201.28,155l10.47,-6c0.48,-0.28 0.87,-0.05 0.87,0.5l0,0.33a1.91,1.91 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.27 -0.87,0 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_74",
    fill: "#ebebeb",
    d: "m201.28,159.67l10.47,-6c0.48,-0.27 0.87,0 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.28 -0.87,0.05 -0.87,-0.5l0,-0.34a1.89,1.89 0 0 1 0.87,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_75",
    fill: "#ebebeb",
    d: "m201.28,164.35l10.47,-6c0.48,-0.28 0.87,-0.06 0.87,0.5l0,0.33a1.92,1.92 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.27 -0.87,0.05 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_76",
    fill: "#ebebeb",
    d: "m201.28,169l17.4,-10c0.48,-0.28 0.87,-0.06 0.87,0.5l0,0.33a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.87,0.05 -0.87,-0.5l0,-0.34a1.89,1.89 0 0 1 0.87,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_77",
    fill: "#ebebeb",
    d: "m201.28,173.72l17.4,-10c0.48,-0.28 0.87,-0.05 0.87,0.5l0,0.33a1.89,1.89 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.87,0.05 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_78",
    fill: "#e0e0e0",
    d: "m87.9,251l0,1.56c0,0.77 0.54,1.08 1.21,0.7l20.15,-11.64a2.65,2.65 0 0 0 1.21,-2.08l0,-1.54c0,-0.77 -0.54,-1.08 -1.21,-0.69l-20.15,11.63a2.67,2.67 0 0 0 -1.21,2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_79",
    fill: "#fafafa",
    d: "m88.41,216.65l20.91,-12.07c1,-0.55 1.73,-0.11 1.73,1l0,24.14a3.86,3.86 0 0 1 -1.73,3l-20.91,12.07c-1,0.55 -1.73,0.1 -1.73,-1l0,-24.14a3.81,3.81 0 0 1 1.73,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_80",
    fill: "#ebebeb",
    d: "m87.63,245.52a1.4,1.4 0 0 1 -0.7,-0.18a1.7,1.7 0 0 1 -0.75,-1.55l0,-24.14a4.32,4.32 0 0 1 2,-3.43l20.91,-12.07a1.54,1.54 0 0 1 2.48,1.43l0,24.14a4.32,4.32 0 0 1 -2,3.43l-20.91,12.07a2.09,2.09 0 0 1 -1.03,0.3zm0.78,-28.87l0.25,0.43a3.32,3.32 0 0 0 -1.48,2.57l0,24.14a0.58,0.58 0 0 0 1,0.57l20.91,-12.08a3.33,3.33 0 0 0 1.48,-2.56l0,-24.14a0.58,0.58 0 0 0 -1,-0.57l-20.91,12.07l-0.25,-0.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_81",
    fill: "#696CFF",
    d: "m111.78,207.84l-4.66,2.69a3.82,3.82 0 0 0 -1.74,3l0,5.38c0,1.1 0.78,1.55 1.74,1l4.66,-2.69a3.85,3.85 0 0 0 1.73,-3l0,-5.38c0,-1.11 -0.78,-1.55 -1.73,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_82",
    fill: "#ebebeb",
    d: "m90,219.26l10.48,-6c0.47,-0.28 0.86,-0.05 0.86,0.5l0,0.33a1.91,1.91 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.28 -0.86,0 -0.86,-0.5l0,-0.34a1.88,1.88 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_83",
    fill: "#ebebeb",
    d: "m90,223.94l10.48,-6c0.47,-0.27 0.86,-0.05 0.86,0.51l0,0.33a1.94,1.94 0 0 1 -0.86,1.5l-10.48,6c-0.48,0.27 -0.86,0 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_84",
    fill: "#ebebeb",
    d: "m90,228.63l10.48,-6c0.47,-0.28 0.86,-0.05 0.86,0.5l0,0.33a1.91,1.91 0 0 1 -0.86,1.5l-10.48,6.04c-0.48,0.28 -0.86,0 -0.86,-0.5l0,-0.35a1.88,1.88 0 0 1 0.86,-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_85",
    fill: "#ebebeb",
    d: "m90,233.31l17.4,-10c0.48,-0.28 0.87,0 0.87,0.5l0,0.33a1.89,1.89 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.86,0.06 -0.86,-0.5l0,-0.34a1.91,1.91 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_86",
    fill: "#ebebeb",
    d: "m90,238l17.4,-10c0.48,-0.27 0.87,0 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.86,0.05 -0.86,-0.5l0,-0.35a1.91,1.91 0 0 1 0.86,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_87",
    fill: "#e0e0e0",
    d: "m124.46,229.89l0,1.57c0,0.76 0.54,1.08 1.2,0.69l20.16,-11.64a2.62,2.62 0 0 0 1.2,-2.08l0,-1.56c0,-0.77 -0.53,-1.08 -1.2,-0.7l-20.16,11.64a2.67,2.67 0 0 0 -1.2,2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_88",
    fill: "#fafafa",
    d: "m125,195.54l20.9,-12.07c1,-0.55 1.74,-0.1 1.74,1l0,24.14a3.82,3.82 0 0 1 -1.74,3l-20.9,12.07c-1,0.56 -1.74,0.11 -1.74,-1l0,-24.14a3.85,3.85 0 0 1 1.74,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_89",
    fill: "#ebebeb",
    d: "m124.19,224.42a1.4,1.4 0 0 1 -0.7,-0.18a1.73,1.73 0 0 1 -0.76,-1.56l0,-24.14a4.33,4.33 0 0 1 2,-3.43l20.89,-12.11a1.55,1.55 0 0 1 2.49,1.43l0,24.14a4.29,4.29 0 0 1 -2,3.43l-20.9,12.08a2.09,2.09 0 0 1 -1.02,0.34zm22.46,-40.68a1,1 0 0 0 -0.53,0.17l-20.9,12.09a3.31,3.31 0 0 0 -1.49,2.56l0,24.14a0.77,0.77 0 0 0 0.26,0.69a0.8,0.8 0 0 0 0.73,-0.12l20.9,-12.07a3.33,3.33 0 0 0 1.49,-2.57l0,-24.16a0.8,0.8 0 0 0 -0.26,-0.69a0.45,0.45 0 0 0 -0.2,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_90",
    fill: "#696CFF",
    d: "m148.33,186.73l-4.66,2.69a3.86,3.86 0 0 0 -1.73,3l0,5.38c0,1.11 0.78,1.56 1.73,1l4.66,-2.69a3.82,3.82 0 0 0 1.74,-3l0,-5.38c0,-1.1 -0.78,-1.55 -1.74,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_91",
    fill: "#ebebeb",
    d: "m126.56,198.15l10.47,-6c0.48,-0.27 0.87,-0.05 0.87,0.51l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.27 -0.87,0.05 -0.87,-0.51l0,-0.34a1.92,1.92 0 0 1 0.87,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_92",
    fill: "#ebebeb",
    d: "m126.56,202.84l10.47,-6c0.48,-0.28 0.87,-0.05 0.87,0.5l0,0.33a1.89,1.89 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.28 -0.87,0.05 -0.87,-0.5l0,-0.35a1.89,1.89 0 0 1 0.87,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_93",
    fill: "#ebebeb",
    d: "m126.56,207.52l10.47,-6c0.48,-0.27 0.87,-0.05 0.87,0.5l0,0.34a1.92,1.92 0 0 1 -0.87,1.5l-10.47,6c-0.48,0.28 -0.87,0.06 -0.87,-0.5l0,-0.36a1.92,1.92 0 0 1 0.87,-1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_94",
    fill: "#ebebeb",
    d: "m126.56,212.2l17.4,-10c0.48,-0.27 0.87,-0.05 0.87,0.5l0,0.3a1.92,1.92 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.27 -0.87,0.05 -0.87,-0.5l0,-0.35a1.92,1.92 0 0 1 0.87,-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_95",
    fill: "#ebebeb",
    d: "m126.56,216.89l17.4,-10c0.48,-0.28 0.87,-0.05 0.87,0.5l0,0.33a1.91,1.91 0 0 1 -0.87,1.5l-17.4,10c-0.48,0.28 -0.87,0 -0.87,-0.5l0,-0.34a1.89,1.89 0 0 1 0.87,-1.49z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_96",
    fill: "#696CFF",
    points: "29.80999755859375,121.91000366210938 25.75,119.53999328613281 25.75,138.30999755859375 29.80999755859375,140.66000366210938 29.80999755859375,121.91000366210938 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_97",
    opacity: 0.1,
    points: "29.80999755859375,121.91000366210938 25.75,119.53999328613281 25.75,138.30999755859375 29.80999755859375,140.66000366210938 29.80999755859375,121.91000366210938 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_98",
    fill: "#696CFF",
    d: "m236.73,206.47l0,0a2.9,2.9 0 0 0 -2.88,0.28a9,9 0 0 0 -4.08,7a2.88,2.88 0 0 0 1.18,2.64l0,0l50.62,32l0,0c1,0.7 2.51,0.66 4.16,-0.29a12.55,12.55 0 0 0 5.71,-9.83c0,-1.9 -0.7,-3.21 -1.82,-3.76l0,0l-52.89,-28.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_99",
    opacity: 0.15,
    d: "m229.77,213.79c0,2.59 1.81,3.65 4.06,2.36a9,9 0 0 0 4.08,-7c0,-2.59 -1.81,-3.65 -4.06,-2.36a9,9 0 0 0 -4.08,7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_100",
    fill: "#263238",
    d: "m218.57,199.74a5.43,5.43 0 0 0 -2.47,4.26a1.74,1.74 0 0 0 0.71,1.59l0,0l15.28,8.87l0,0a1.71,1.71 0 0 0 1.73,-0.17a5.4,5.4 0 0 0 2.48,-4.29a1.72,1.72 0 0 0 -0.71,-1.6l-15.28,-8.87l0,0a1.73,1.73 0 0 0 -1.74,0.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_101",
    opacity: 0.1,
    d: "m235.74,214.49l52.08,32a10,10 0 0 1 -2.08,1.65c-1.65,0.95 -3.13,1 -4.17,0.29l0,0l-50.61,-32a2.85,2.85 0 0 0 2.87,-0.28a7.41,7.41 0 0 0 1.91,-1.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_102",
    fill: "#696CFF",
    d: "m244.48,168.93c0,-0.43 0,-0.84 -0.06,-1.26s-0.05,-0.83 -0.1,-1.24s-0.05,-0.54 -0.08,-0.81c-0.07,-0.72 -0.18,-1.42 -0.29,-2.09c-0.06,-0.3 -0.11,-0.62 -0.17,-0.92s-0.12,-0.57 -0.18,-0.86c-0.18,-0.77 -0.36,-1.53 -0.58,-2.25c-0.12,-0.34 -0.22,-0.69 -0.34,-1a1.42,1.42 0 0 1 -0.05,-0.16c-0.13,-0.34 -0.24,-0.66 -0.37,-1a11.68,11.68 0 0 0 -0.46,-1.08a7.76,7.76 0 0 0 -0.37,-0.77a3,3 0 0 0 -0.27,-0.54c-0.1,-0.22 -0.22,-0.44 -0.34,-0.65l-0.09,-0.15c-0.1,-0.19 -0.22,-0.37 -0.33,-0.56s-0.16,-0.24 -0.23,-0.36a20,20 0 0 0 -1.8,-2.4c-0.12,-0.12 -0.23,-0.25 -0.34,-0.37s-0.19,-0.2 -0.28,-0.3l-0.37,-0.36a11.08,11.08 0 0 0 -1.09,-1a5.79,5.79 0 0 0 -0.55,-0.43c-0.19,-0.15 -0.38,-0.29 -0.58,-0.42a9.29,9.29 0 0 0 -0.93,-0.61l-0.25,-0.16l-0.05,0l0,0l-11,-6.39l0,0l-0.08,-0.05a18.65,18.65 0 0 0 -9.32,-2.36c-4.86,0 -10.34,1.6 -16.15,4.95c-20,11.52 -36.14,39.54 -36.14,62.6c0,11.49 4,19.57 10.52,23.36l0.06,0l0,0l11,6.38l0,0l0.06,0l0,0l0.18,0.1c0.29,0.16 0.57,0.31 0.86,0.45s0.72,0.33 1.09,0.48s0.66,0.26 1,0.36a3.68,3.68 0 0 0 0.54,0.16a3.08,3.08 0 0 0 0.57,0.17l0.59,0.15a3.29,3.29 0 0 0 0.43,0.09l0.78,0.14l0.18,0l0.94,0.12c5.39,0.57 11.65,-0.95 18.35,-4.81c20,-11.53 36.14,-39.56 36.14,-62.6c-0.02,-0.48 -0.03,-1 -0.05,-1.55zm-24.21,-16.3a32.35,32.35 0 0 1 1.14,8.8c0,20.33 -14.88,46.09 -32.48,56.25a31.41,31.41 0 0 1 -8.24,3.43a32.37,32.37 0 0 1 -1.14,-8.81c0,-20.33 14.87,-46.09 32.48,-56.25a31.22,31.22 0 0 1 8.24,-3.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_103",
    opacity: 0.1,
    d: "m182.3,235.42l-10.6,-6.14c-6.5,-3.8 -10.52,-11.89 -10.52,-23.36c0,-10.28 3.22,-21.54 8.55,-31.89l11,6.39c-5.34,10.34 -8.56,21.61 -8.56,31.89c0.04,11.24 3.83,19.21 10.13,23.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_104",
    opacity: 0.4,
    fill: "currentColor",
    d: "m244.48,168.93c0,-0.43 0,-0.84 -0.06,-1.26s-0.05,-0.83 -0.1,-1.24s-0.05,-0.54 -0.08,-0.81c-0.07,-0.72 -0.18,-1.42 -0.29,-2.09c-0.06,-0.3 -0.11,-0.62 -0.17,-0.92s-0.12,-0.57 -0.18,-0.86c-0.18,-0.77 -0.36,-1.53 -0.58,-2.25c-0.12,-0.34 -0.22,-0.69 -0.34,-1a1.42,1.42 0 0 1 -0.05,-0.16c-0.13,-0.34 -0.24,-0.66 -0.37,-1a11.68,11.68 0 0 0 -0.46,-1.08a7.76,7.76 0 0 0 -0.37,-0.77a3,3 0 0 0 -0.27,-0.54c-0.1,-0.22 -0.22,-0.44 -0.34,-0.65l-0.09,-0.15c-0.1,-0.19 -0.22,-0.37 -0.33,-0.56s-0.16,-0.24 -0.23,-0.36a20,20 0 0 0 -1.8,-2.4c-0.12,-0.12 -0.23,-0.25 -0.34,-0.37s-0.19,-0.2 -0.28,-0.3l-0.37,-0.36a11.08,11.08 0 0 0 -1.09,-1a5.79,5.79 0 0 0 -0.55,-0.43c-0.19,-0.15 -0.38,-0.29 -0.58,-0.42a9.29,9.29 0 0 0 -0.93,-0.61c-6.56,-4 -16,-3.9 -25.86,2.33c-19.81,12.48 -36.05,40.15 -36.15,62.6c-0.05,11.68 4.14,19.83 10.83,23.54c0.29,0.16 0.57,0.31 0.86,0.45s0.72,0.33 1.09,0.48s0.66,0.26 1,0.36a3.68,3.68 0 0 0 0.54,0.16a3.08,3.08 0 0 0 0.57,0.17l0.59,0.15a3.29,3.29 0 0 0 0.43,0.09l0.78,0.14l0.18,0l0.94,0.12c5.39,0.57 11.65,-0.95 18.35,-4.81c20,-11.53 36.14,-39.56 36.14,-62.6c-0.01,-0.52 -0.02,-1.04 -0.04,-1.59zm-39.78,57.9c-4.48,2.59 -8.79,3.95 -12.48,3.95c-6.92,0 -10.1,-4.72 -11.53,-9.67a32.37,32.37 0 0 1 -1.14,-8.81c0,-20.33 14.87,-46.09 32.48,-56.25a31.22,31.22 0 0 1 8.24,-3.42a18.49,18.49 0 0 1 4.24,-0.53c11.44,0 12.66,12.92 12.66,18.48c0,20.33 -14.86,46.09 -32.47,56.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_105",
    opacity: 0.1,
    d: "m237.17,170.58c0,20.32 -14.86,46.09 -32.47,56.25c-4.48,2.59 -8.79,3.95 -12.47,3.95a10.61,10.61 0 0 1 -8.51,-3.73l0,0c-0.18,-0.21 -0.35,-0.43 -0.52,-0.65s-0.33,-0.45 -0.47,-0.69a5.33,5.33 0 0 1 -0.31,-0.51c-0.07,-0.11 -0.14,-0.22 -0.2,-0.33s-0.14,-0.28 -0.22,-0.42s-0.13,-0.26 -0.19,-0.39s-0.13,-0.26 -0.19,-0.4l-0.3,-0.72c-0.12,-0.3 -0.23,-0.6 -0.33,-0.91s-0.21,-0.61 -0.29,-0.92a31.41,31.41 0 0 0 8.24,-3.43c17.6,-10.16 32.48,-35.92 32.48,-56.25a32.35,32.35 0 0 0 -1.14,-8.8a18.49,18.49 0 0 1 4.24,-0.53a14.84,14.84 0 0 1 1.67,0.1l0.52,0.08l0,0c9.39,1.56 10.46,13.12 10.46,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_106",
    opacity: 0.7,
    fill: "currentColor",
    d: "m230.85,167c0,20.33 -14.86,46.09 -32.47,56.25c-4.48,2.59 -8.79,4 -12.48,4a12.78,12.78 0 0 1 -2.19,-0.18c-0.18,-0.21 -0.35,-0.43 -0.52,-0.65s-0.33,-0.45 -0.47,-0.69a5.33,5.33 0 0 1 -0.31,-0.51c-0.07,-0.11 -0.14,-0.22 -0.2,-0.33s-0.14,-0.28 -0.22,-0.42s-0.13,-0.26 -0.19,-0.39s-0.13,-0.26 -0.19,-0.4l-0.3,-0.72c-0.12,-0.3 -0.23,-0.6 -0.33,-0.91s-0.21,-0.61 -0.29,-0.92a31.41,31.41 0 0 0 8.24,-3.43c17.6,-10.16 32.48,-35.92 32.48,-56.25a32.35,32.35 0 0 0 -1.14,-8.8a18.49,18.49 0 0 1 4.24,-0.53a14.84,14.84 0 0 1 1.67,0.1l0.52,0.08c3.62,4.24 4.15,11.07 4.15,14.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5d594089fac8a30e7f68ddd98d2c1f4e.svg";
export { ForwardRef as ReactComponent };